<ngx-spinner></ngx-spinner>
<app-header></app-header>
<div class="wrapper">
  <div class="container">
    <div class="row mt-4 pb-4">
      <div class="col-12 text-center">
        <h2 class="manage-profile-heading">
          {{ "WATCH_PROFILE.WATCH" | translate }}
        </h2>
        <ul class="profile-user-list">
          <li *ngFor="let data of peopleData">
            <a
              class="manage-profile icon-bg-{{ data.color }}"
              (click)="
                data.id != userInfo?.profile_id ? changeProfile(data) : ''
              "
              [ngClass]="{ active: data.id === userInfo.profile_id }"
            >
              <span
                *ngIf="data.id == userInfo?.people_profile[0]?.id"
                class="w-100 h-100 position-relative"
              >
                <span *ngIf="userInfo.image" class="circle min-profile d-block">
                  <img src="{{ userInfo.image }}" class="w-100"
                /></span>

                <span *ngIf="!userInfo.image" class="defult-watch-img">
                  <img src="assets/images/user-icon.png" class="w-100" />
                </span>
              </span>
              <span *ngIf="data.id != userInfo?.people_profile[0]?.id">
                <img src="assets/images/user-icon.png" class="w-100" />
              </span>
            </a>
            <span>{{ data.name }}</span>
          </li>
          <!-- <li>
            <a href="javascript:void(0)" class="manage-profile icon-bg-red active">
              <img src="assets/images/user-icon.png" class="w-100" />
            </a>
            <span>Abhishek</span>
          </li>
          <li>
            <a href="javascript:void(0)" class="manage-profile icon-bg-yellow">
              <img src="assets/images/user-icon.png" class="w-100" />
            </a>
            <span>Mayur</span>
          </li>
          <li>
            <a href="javascript:void(0)" class="manage-profile icon-bg-purple">
              <img src="assets/images/user-icon.png" class="w-100" />
            </a>
            <span>Ajay</span>
          </li> -->
          <li>
            <a [routerLink]="['/manage-profile/add']" class="add-btn">
              <span class="mdi mdi-plus"></span>
            </a>
            <span>{{ "WATCH_PROFILE.ADD_NEW" | translate }}</span>
          </li>
        </ul>
        <button
          type="button"
          class="btn btn-theme"
          [routerLink]="['/manage-profile']"
          [queryParams]="{ profile_id: userInfo.profile_id }"
        >
          {{ "WATCH_PROFILE.EDIT_PROFILE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
